export default class ServisPlanOptionsService{

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("listServisTyp");
  }

  save(item){
    return this.server("saveServisTyp", {nazov: item.nazov, skratka: item.skratka, farba:item.farba});
  }

  remove(item){
    return this.server("removeServisTyp", {id: item.id});
  }

  update(item){
    return this.server("saveServisTyp", {id: item.id, nazov: item.nazov, skratka: item.skratka, farba:item.farba});
  }


}


// WEBPACK FOOTER //
// ./src/services/ServisPlanOptionsService.js